import { DataTable } from "@/components/data-table"
import { StackProps } from "@mui/material"
import { BodyTypography, HeaderTypography } from "./table-typography"
import { formatNumber, formatString } from "@/shared/formats"
import { getTransferenciaMetodoMonedaCantidad } from "@/features/monetizacion/shared/utils"
import { CajaApertura } from "@/shared/types/caja-apertura"
import { TransferenciaMetodo } from "@/shared/types/transferencia-metodo"
import { Moneda } from "@/shared/types/moneda"

export interface SharedCajaAperturaTransferenciaMetodoSummaryTableProps extends StackProps {
    cajaApertura: CajaApertura,
    transferenciaMetodo: TransferenciaMetodo,
    monedas: Moneda[]
}

export default function SharedCajaAperturaTransferenciaMetodoSummaryTable({
    cajaApertura,
    transferenciaMetodo,
    monedas,
    ...props
}: SharedCajaAperturaTransferenciaMetodoSummaryTableProps) {
    return <DataTable {...props}>
        <DataTable.Content
            rows={monedas}
            columns={[
                {
                    header: <HeaderTypography transferenciaMetodo={transferenciaMetodo}>{transferenciaMetodo.nombre}</HeaderTypography>,
                    render: moneda => <BodyTypography transferenciaMetodo={transferenciaMetodo} moneda={moneda}>
                        {formatString(moneda.nombre)} ({formatString(moneda.simbolo)})
                    </BodyTypography>
                },
                {
                    header: <HeaderTypography transferenciaMetodo={transferenciaMetodo}>Monto Inicial</HeaderTypography>,
                    render: moneda => <BodyTypography transferenciaMetodo={transferenciaMetodo} moneda={moneda}>
                        {formatNumber(getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaInicial, transferenciaMetodo.id, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                {
                    header: <HeaderTypography transferenciaMetodo={transferenciaMetodo}>Monto Calculado</HeaderTypography>,
                    render: moneda => <BodyTypography transferenciaMetodo={transferenciaMetodo} moneda={moneda}>
                        {formatNumber(getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaTotal, transferenciaMetodo.id, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                cajaApertura.transferenciaReal && {
                    header: <HeaderTypography transferenciaMetodo={transferenciaMetodo}>Monto Real</HeaderTypography>,
                    render: moneda => <BodyTypography transferenciaMetodo={transferenciaMetodo} moneda={moneda}>
                        {formatNumber(getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaReal!, transferenciaMetodo.id, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                },
                cajaApertura.transferenciaDiferencia && {
                    header: <HeaderTypography transferenciaMetodo={transferenciaMetodo}>Diferencia</HeaderTypography>,
                    render: moneda => <BodyTypography transferenciaMetodo={transferenciaMetodo} moneda={moneda}>
                        {formatNumber(getTransferenciaMetodoMonedaCantidad(cajaApertura.transferenciaDiferencia!, transferenciaMetodo.id, moneda.id))}
                    </BodyTypography>,
                    align: "right",
                    width: "auto"
                }
            ]}
        />
    </DataTable>
}